import type { ILead } from 'src/services/api/leads/types';

export const insertLeadByInsertedAt = (
    sortedLeads: ILead[],
    leadToInsert: ILead,
): ILead[] => {
    const insertedAt = Date.parse(leadToInsert.inserted_at);
    const insertIndex = sortedLeads.findIndex(
        (lead) => Date.parse(lead.inserted_at) < insertedAt,
    );

    if (insertIndex < 0) {
        return [...sortedLeads, leadToInsert];
    }

    return [
        ...sortedLeads.slice(0, insertIndex),
        leadToInsert,
        ...sortedLeads.slice(insertIndex),
    ];
};
